import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Switch, Route, HashRouter as Router, withRouter } from 'react-router-dom';


//IMPORT IMAGES

//IMPORT REDUX
import { connect } from 'react-redux';

//IMPORT REACT COMPONENTS
import ProtectedAcceuilComponent from './Acceuil/ProtectedAcceuilComponent'
import TravauxComponent from './Travaux/TravauxComponent'
import ListesComponent from './Listes/ListesComponent';
import ListesDetailsComponent from './Listes/ListesDetailsComponent';
import ExtensionsContentComponent from './Extension/ExtensionContentComponent';
import ParametresComponent from './Parametre/ParametresComponent'
import ContactUsComponent from './Contact/ContactUsComponent';
import RechercheComponent from './Recherche/RechercheComponent';


const mapStateToProps = state => {
    return { token: state }
}

class ConnectedProtectedRouter extends React.Component {

    constructor(props) {
        super(props)
    }
    render() {
        return (
            <main>
                <Switch>
                    <Route path='/homepage' component={ProtectedAcceuilComponent} />
                    <Route path="/works/:id(\d+)" component={TravauxComponent}/>
                    <Route path='/works/:beta(beta)/:id(\d+)' component={TravauxComponent} />
                    <Route path='/works/:beta(beta)' component={TravauxComponent} />
                    <Route path='/works' component={TravauxComponent} />
                    <Route path='/lists' component={ListesComponent} />
                    <Route path='/listdetail/:id' component={ListesDetailsComponent} />
                    <Route path='/subs' component={ExtensionsContentComponent} />
                    <Route path='/settings' component={ParametresComponent} />
                    <Route path='/contact' component={ContactUsComponent} />
                    <Route path='/recherche' component={RechercheComponent} />
                </Switch>
            </main>
        );
    }
}

// const MainComponent = connect(mapStateToProps)(ConnectedMainComponent);
// export default MainComponent;

const ProtectedRouter = withRouter(connect(mapStateToProps)(ConnectedProtectedRouter));
export default ProtectedRouter


// WEBPACK FOOTER //
// ./src/components/Protected/ProtectedRouter.js